// src/features/loginSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseUrl, apiKey } from '../../../utils/config';

export const loginUser = createAsyncThunk(
    'login/loginUser',
    async (credentials, { rejectWithValue }) => {
      try {
        const response = await axios.post(`${apiBaseUrl}/trade/login`, {
          api_key: apiKey,
          account: credentials.account,
          password: credentials.password,
        });
  
        if (response.status !== 200) {
          return rejectWithValue(response.data?.error || "Login failed");
        }
  
        return response.data;
      } catch (error) {
        // This is key: send a clear message to your reducer
        return rejectWithValue(
          error.response?.data?.error ||
          error.message ||
          "Login failed due to network/server error"
        );
      }
    }
  );
  

const loginSlice = createSlice({
    name: 'login',
    initialState: {
        user: null,
        account:null,
        loading: false,
        error: null,
    },
    reducers: {
        // Add the resetLoginFlag reducer
        resetLoginFlag: (state) => {
            state.error = null;
            state.user = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    // Create an object that holds both user and account information
                    const userData = {
                        ...action.payload, // Assuming action.payload contains user data
                        // account: action.meta.arg.account, // Add the account info here
                    };

                    // Store user data in local storage
                    localStorage.setItem('user', JSON.stringify(userData));

                    // Handle the successful login
                    state.user = userData; // Save user data directly
                    state.account = action.payload.account
                    state.error = null;
                } else {
                    // Handle other cases if needed
                    state.error = "Login failed, please check your credentials.";
                }
            })

            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Login failed";
            });
    },
});

export const { resetLoginFlag } = loginSlice.actions; // Export the new action

export default loginSlice.reducer;
